<template>
  <div class="box-filter">
    <el-form ref="ruleForm" @submit.prevent v-on:submit.prevent>
      <div class="viewFilter">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="status" label="Planos">
              <SelectSearchPlanos
                :model="plan_id"
                :isEdit="false"
                @handleValue="
                  (x) => {
                    plan_id = x;
                  }
                "
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="plan_anticipation"
              label="Antecipado ?"
            ></el-form-item>
            <div class="block">
              <el-radio v-model="plan_anticipation" label="1" size="large">
                Sim
              </el-radio>
              <el-radio v-model="plan_anticipation" label="0" size="large">
                Não
              </el-radio>
            </div>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
          <el-col :xs="24" :span="15">
            <el-button
              icon="el-icon-download"
              @click="search()"
              type="default"
              size="large"
              style="float: right; margin-right: 20px"
            >
              Exportar
            </el-button>
            <el-button
              @click="clearSearch"
              type="default"
              size="large"
              style="float: right; margin-right: 20px"
            >
              Limpar Filtros
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import SelectSearchPlanos from "@/app/components/Planos/SelectSearchPlanos";

export default {
  name: "FilterBox",
  components: {
    SelectSearchPlanos,
  },
  data() {
    return {
      loadingPage: true,
      query: "?page=1",
      plan_id: null,
      plan_anticipation: "0",
    };
  },
  methods: {
    clearSearch() {
      this.query = "?page=1";
      this.plan_id = null;
      this.plan_anticipation = "0";
    },
    search() {
      if (this.plan_id) {
        this.query = `${this.query}&plan_id=${this.plan_id}`;
      }
      if (this.plan_anticipation) {
        this.query = `${this.query}&plan_anticipation=${this.plan_anticipation}`;
      }
      this.$emit("filterExport", this.query);
      this.clearSearch();
    },
  },
};
</script>

<style scoped></style>
